import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#4b2e8b',
                secondary: '#16BAAF',
                accent: '#8c9eff',
                success: '#4CAF50',
                error: '#FF5252',
                background: '#F6F8FA',
            },
        },options: {
            customProperties: true
        },
    },
});